<l-list-container
  class="tags-list-table"
  [size]="limit"
  [page]="page"
  [data]="data"
  [sort]="sort"
  [total]="total"
  [isLoading]="isLoading"
  (onPage)="pageChange.emit($event)"
  (onSort)="sortChange.emit($event)"
>
  <ng-template #header>
    <th lSortable="name">Nome</th>
    <th lSortable="createdAt">Criado em</th>
    <th lSortable="updatedAt">Última atualização</th>
    <th class="w-12"></th>
  </ng-template>

  <ng-template #body let-tag>
    <td class="align-middle">
      <span class="inline-flex items-center gap-2 rounded-full bg-lGray700/60 px-3 py-1 text-sm text-lWhite">
        <l-icon icon="sell" class="text-base text-lGray500" />
        <span class="inline-block first-letter:uppercase">{{ tag.name }}</span>
      </span>
    </td>

    <td class="align-middle">{{ tag.createdAt ? (tag.createdAt | date: 'yyyy-MM-dd') : '—' }}</td>

    <td class="align-middle">{{ tag.updatedAt ? (tag.updatedAt | date: 'yyyy-MM-dd') : '—' }}</td>

    <td class="align-middle">
      @let actions = getRowActions(tag);

      @if (actions.length > 0) {
        <button
          class="flex h-7 w-7 items-center justify-center rounded text-lGray600 transition-colors hover:bg-lGray700/70 hover:text-lWhite"
          aria-label="Ações da tag"
          (click)="rowMenu.toggle($event)"
        >
          <l-icon icon="more_vert" />
        </button>

        <l-modal-actions #rowMenu [actions]="actions" />
      }
    </td>
  </ng-template>
</l-list-container>
